module.exports = __webpack_public_path__ + "img/mini_but_many.banner.b39a6858.jpg";